import { render } from "./OperadoresView.vue?vue&type=template&id=99330904"
import script from "./OperadoresView.vue?vue&type=script&lang=js"
export * from "./OperadoresView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__